// Import model
import { SfLead } from '../models/SfLead';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Customer } from '../models/Customer';

// Import dependency serializers (for complex types)
import { CustomerSerializer } from './CustomerSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfLead - handles JSON serialization and deserialization with type validation
 */
export class SfLeadSerializer {
  /**
   * Deserializes a JSON string into a SfLead instance
   */
  static deserialize(json: string): SfLead {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfLead instance
   */
  static fromObject(obj: any): SfLead {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfLead');
    }


    const instance: SfLead = {
      address: obj['address'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      email: obj['email'] as string | undefined,
      customer: obj['customer'] ? CustomerSerializer.fromObject(obj['customer']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfLead instances
   */
  static deserializeArray(json: string): SfLead[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfLead instance to a JSON string
   */
  static serialize(instance: SfLead): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfLead instance to a plain object
   */
  static toObject(instance: SfLead): any {
    return {
      'address': instance.address,
      'phone': instance.phone,
      'email': instance.email,
      'customer': instance.customer ? CustomerSerializer.toObject(instance.customer) : undefined,
    };
  }

  /**
   * Serializes an array of SfLead instances to a JSON string
   */
  static serializeArray(instances: SfLead[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
